import React from 'react';
import TableC from '../../../basicElement/TableC';

function getRender(text, record){
    const { performanceItemId } = record;
    if (!performanceItemId) {
        return <strong>{text}</strong>;
    }
    return text;
}

export default function Minus(props) {
    const { loading, data } = props;

    const getColumns = () => ([
    {
        title: '考核项',
        dataIndex: 'performanceItemName',
        key: 'performanceItemName',
        width: 100,
        render: getRender
    }, {
        title: '得分',
        dataIndex: 'score',
        key: 'score',
        width: 100,
        render: getRender
    }]);

    const getDataSource = () => {
        return data || [];
    };

    return (
        <div>
            <div style={{ lineHeight: '48px' }}>1.减分明细</div>
            <TableC
                loading={loading}
                columns={getColumns()}
                data={getDataSource()}
                className="minus"
            />
        </div>
    );
}



// WEBPACK FOOTER //
// ./src/components/home/TeachingDetail/tables/Minus.js